// extracted by mini-css-extract-plugin
export default {"weekWrapper":"days-of-week_weekWrapper__ds4BG"};